import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { AuthCredentials } from "projects/admin/src/app/models/auth-credentials";
import { Observable, throwError } from "rxjs";
import { LegacyApiError } from "projects/admin/src/app/models/api-response";
import { AuthToken } from "projects/admin/src/app/models/auth-token";
import { catchError, map } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class LegacyService {

  baseAPIUrl: string = environment.legacyAPIUrl;

  constructor(
    private http: HttpClient
  ) {}

  public access(credentials: AuthCredentials): Observable<AuthToken> {
    return this.http.post<AuthToken>(`${this.baseAPIUrl}/V8/auth/access`, credentials)
      .pipe(map(unit => <AuthToken>unit),
      catchError(error => this.handleError(error)));
  }

  public deleteUser(accessToken: string, params: any): Observable<void> {
    return this.http.request<void>('delete', `${this.baseAPIUrl}/V8/users/me/request-deletion`, {
      body: params,
      headers: {
        'Authorization': `Bearer ${accessToken}`
      }
    })
    .pipe(map(unit => {}),
      catchError(error => this.handleError(error)));
  }

  private handleError(res: HttpErrorResponse | any) {
    let error = <LegacyApiError>res.error;
    return throwError(error);
  }
}
